import tableIncome from './TableIncome';
import tableUsers from './TableUsers';
import tablePartners from './TablePartners';

export const TableIncome = tableIncome;
export const TableUsers = tableUsers;
export const TablePartners = tablePartners;
